export default __webpack_public_path__ + "static/media/logo1.28fd68f0.png";